import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Store } from "@ngxs/store";
import { environment } from "../../../../environments/environment";
import { NzUploadChangeParam, NzUploadFile, NzUploadModule, NzUploadType } from 'ng-zorro-antd/upload';
import { NzMessageService } from "ng-zorro-antd/message";
import { UploadedFile } from "@app/_models/uploaded-file.model";
import { SettingsState } from "@app/_state/settings.state";
import { CommonModule } from '@angular/common';
import { NzButtonModule, NzButtonSize, NzButtonType } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
    selector: 'app-file-upload',
    template: `
    <nz-upload
      [nzAction]="uploadUrl"
      [nzHeaders]="{ authorization: 'Bearer ' + authToken }"
      [nzType]="type"
      [nzFileList]="fileList"
      (nzChange)="handleUploadChange($event)"
      [nzRemove]="handleRemove"
      [nzAccept]="accept"
      [nzDisabled]="disabled">
      <button type="button" nz-button [nzType]="buttonType" [nzSize]="buttonSize">
        <i nz-icon nzType="upload"></i>
        {{buttonLabel}}
      </button>
    </nz-upload>
  `,
    imports: [
        CommonModule,
        NzUploadModule,
        NzButtonModule,
        NzIconModule,
    ]
})
export class FileUploadComponent implements OnInit {
  private store = inject(Store);
  private messageService = inject(NzMessageService);


  @Input()
  disabled = false;

  @Input()
  type: NzUploadType = 'drag';

  @Input()
  accept: string = '*';

  @Input()
  buttonLabel: string = $localize`Загрузить файл`;

  @Input()
  buttonType: NzButtonType = 'default';

  @Input()
  buttonSize: NzButtonSize = 'default';

  @Input()
  standaloneMode: boolean = false;

  @Input() set files(value: UploadedFile[]) {
    this._files = value;
    if (this._files && this._files.length > 0) {
      console.log(this._files);
      for (const file of this._files) {
        const uploadFile: NzUploadFile = {
          filename: file.name,
          name: file.name,
          percent: 100,
          response: file,
          size: file.size,
          status: undefined,
          type: file.contentType,
          uid: file.id,
          url: this.downloadUrl + '/' + file.id
        };
        if (!this.hasDuplicateFile(uploadFile)) {
          this.fileList = [...this.fileList, uploadFile];
        }
        if (this.standaloneMode) {
          this.fileList = [];
        }
      }
    }
  }

  _files: UploadedFile[] = [];
  fileList: NzUploadFile[] = [];

  @Output() uploaded = new EventEmitter<UploadedFile>();
  @Output() removed = new EventEmitter<UploadedFile>();

  uploadUrl = environment.apiUrl + '/api/upload-file';
  downloadUrl = environment.apiUrl + '/api/download-file';
  authToken?: string;

  ngOnInit(): void {
    this.authToken = this.store.selectSnapshot(SettingsState.token);
  }

  handleUploadChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      const fileResponse = info.file.response;
      if (fileResponse) {
        info.file.uid = fileResponse.id;
        info.file.filename = fileResponse.filename;
        info.file.url = this.downloadUrl + '/' + fileResponse.id;
        if (!this.hasDuplicateFile(info.file)) {
          this.fileList = [...this.fileList, info.file];
        }
        this.uploaded.emit(fileResponse);
        this.messageService.success($localize`Файл ${info.file.name} успешно загружен`);
        if (this.standaloneMode) {
          this.fileList = [];
        }
      }
    } else if (info.file.status === 'error') {
      this.messageService.error($localize`Загрузка файла ${info.file.name} не удалась.`);
    }
  }

  handleRemove = (file: NzUploadFile): boolean => {
    this.removed.emit(file.response);
    return true;
  }

  hasDuplicateFile(uploadFile: NzUploadFile): boolean {
    for (const file of this.fileList) {
      if (file.uid === uploadFile.uid) {
        return true;
      }
    }
    return false;
  }
}
